import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CrystalclearArchiveBackUrl} from "../config/crystalclear-archive-back-url";
import {ProfileAbsService} from "./profile-abs.service";
import {Observable} from "rxjs";
import {ApiValidation} from "../../model/api/api-validation";
import {ReportTask} from "../../model/archive/report-task";
import {FieldRequest} from "../../model/api/field-request";
import {ProfileFieldResult} from "../../model/archive/profile-field-result";

@Injectable({
  providedIn: 'root'
})
export class RecapProfileService extends ProfileAbsService {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_RECAP_PROFILE_LIST,
      CrystalclearArchiveBackUrl.SAVE_ARCHIVE_RECAP_PROFILE,
      CrystalclearArchiveBackUrl.DELETE_ARCHIVE_RECAP_PROFILE,
      CrystalclearArchiveBackUrl.DOWNLOAD_ARCHIVE_RECAP_PROFILE_ASYNC,
      CrystalclearArchiveBackUrl.DOWNLOAD_FORPROFILE_ARCHIVE_RECAP_PROFILE_ASYNC,
      CrystalclearArchiveBackUrl.EXECUTE_ARCHIVE_RECAP_PROFILE_ASYNC,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_RECAP_PROFILE_EXPORT_TEMPLATES_FORM,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_RECAP_PROFILE_EXPORT_TEMPLATES_PROFILE,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_RECAP_PROFILE_PROFILES_FIELDS_FORM,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_RECAP_PROFILE_MAIL_TEMPLATES,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_RECAP_PROFILE_FILE_LOCATIONS,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_RECAP_BATCH_UPDATE);
  }

  public syncProfilesWithExporter(): Observable<ApiValidation<string>> {
    return this.get(CrystalclearArchiveBackUrl.GET_SYNC_PROFILES_WITH_EXPORTER);
  }

  public syncTemplatesWithExporter(): Observable<ApiValidation<string>> {
    return this.get(CrystalclearArchiveBackUrl.GET_SYNC_TEMPLATES_WITH_EXPORTER);
  }

  public generateTestProfilesFromTemplates(): Observable<ApiValidation<string>> {
    return this.get(CrystalclearArchiveBackUrl.GET_GENERATE_TEST_PROFILES_FROM_TEMPLATES);
  }

  public executeDiffAsync(differential: boolean, profileNames: string[]): Observable<ApiValidation<string>> {
    return this.post(CrystalclearArchiveBackUrl.EXECUTE_DIFF_ARCHIVE_RECAP_PROFILE_ASYNC, profileNames,
      {
        origin: ReportTask.Origin.WEB_RECAP,
        differential: differential.toString()
      });
  }

  public getProfileFieldsList(request: FieldRequest): Observable<ProfileFieldResult> {
    return this.post(CrystalclearArchiveBackUrl.GET_ARCHIVE_RECAP_PROFILE_PROFILES_FIELDS_LIST, request);
  }
}
